import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Login from './component/Login';
import KarkhanaList_details_Information from './component/KarkhanaList_details_Information';
import Menu from './component/Menu';
import TransportHomePage from './component/TransportHomePage';
import TransportInformation from './component/TransportInformation';
import KamgarInformation from './component/KamgarInformation';
import VehicleFillInfo_Show_Details from './component/VehicleFillInfo_Show_Details';
import KamgarFillInfo_Show_Details from './component/KamgarFillInfo_Show_Details';
import MukadamFillInfo_Show_Details from './component/MukadamFillInfo_Show_Details';
import EnterOtp from './component/EnterOtp';
import MobileNumber from './component/MobileNumber';
import AfterOTPChangePass from './component/AfterOTPChangePass';
import UserProfile from './component/UserProfile';
import UsTodKamgaranchiMahiti from './component/UsTodKamgaranchiMahiti';
import UstodaniMukadamachiMahiti from './component/UstodaniMukadamachiMahiti';
import CardDetail from './component/CardDetail';
import ChangeUserPassword from './component/ChangeUserPassword';
import FactoryInformationPage from './component/FactoryInformationPage';
import BlakListMukadamReason from './component/BlakListMukadamReason';
import BlakListKamgarReason from './component/BlakListKamgarReason';
import BlackListShow from './component/BlackListShow';
import BlaclkListKamgarShow from './component/BlaclkListKamgarShow';

class App extends React.Component {
    render() {
        return (
            <div className="view view-main">
                <div className="pages">
                    <div data-page="index" className="page homepage">
                        <div className="page-content">
                            <Switch>
                                <Route exact path='/' component={Menu} />
                                <Route path='/login' component={Login} />
                                <PrivateRoute path='/ChangeUserPassword' component={ChangeUserPassword} />
                                <PrivateRoute path='/TransportHomePage' component={TransportHomePage} />
                                <PrivateRoute path='/EnterOtp' component={EnterOtp} />
                                <PrivateRoute path='/MobileNumber' component={MobileNumber} />
                                <PrivateRoute path='/AfterOTPChangePass' component={AfterOTPChangePass} />
                                <PrivateRoute path='/FactoryInformationPage' component={FactoryInformationPage} />
                                <PrivateRoute path='/KarkhanaList_details_Information' component={KarkhanaList_details_Information} />
                                <PrivateRoute path='/TransportInformation' component={TransportInformation} />
                                <PrivateRoute path='/VehicleFillInfo_Show_Details' component={VehicleFillInfo_Show_Details} />
                                <PrivateRoute path='/MukadamFillInfo_Show_Details' component={MukadamFillInfo_Show_Details} />
                                <PrivateRoute path='/KamgarFillInfo_Show_Details' component={KamgarFillInfo_Show_Details} />
                                <PrivateRoute path='/UserProfile' component={UserProfile} />
                                <PrivateRoute path='/UsTodKamgaranchiMahiti' component={UsTodKamgaranchiMahiti} />
                                <PrivateRoute path='/UstodaniMukadamachiMahiti' component={UstodaniMukadamachiMahiti} />
                                <PrivateRoute path='/CardDetail' component={CardDetail} />
                                <PrivateRoute path='/KamgarInformation' component={KamgarInformation} />
                                <PrivateRoute path='/BlakListMukadamReason' component={BlakListMukadamReason} />
                                <PrivateRoute path='/BlakListKamgarReason' component={BlakListKamgarReason} />
                                <PrivateRoute path='/BlackListShow' component={BlackListShow} />
                                <PrivateRoute path='/BlaclkListKamgarShow' component={BlaclkListKamgarShow} />
        
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        sessionStorage.getItem("User") != null
            ? < Component { ...props }/>
            : <Redirect to='/Login'/>
    )} />
)
export default App





// WEBPACK FOOTER //
// ./src/App.js